export const EngErrorMessageConstant = {
  NotExistEmail: 'Email does not exist in the system.',
  AlreadyExistEmail: 'Email already exists in the system.',
  AlreadyExistCitizenNumber: 'Citizen number already exists in the system.',
  InvalidKitchenCenterId: 'Kitchen center id is not suitable id in the system.',
  InvalidBrandId: 'Brand id is not suitable id in the system.',
  InvalidStoreId: 'Store id is not suitable id in the system.',
  InvalidCategoryId: 'Category id is not suitable id in the system.',
  InvalidBankingAccountId: 'Banking account id is not suitable id in the system.',
  InvalidCashierId: 'Cashier id is not suitable id in the system.',
  InvalidProductId: 'Product id is not suitable id in the system.',
  IdNotSuitable: 'Id is not suitable id in the system.',
  KitchenCenterIdNotSuitable: 'Id Kitchen Center is not suitable id in the system.',
  BrandIdNotSuitable: 'Id Brand is not suitable id in the system.',
  CategoryIdNotSuitable: 'Id Category is not suitable id in the system.',
  ProductIdNotSuitable: 'Product Id is not suitable id in the system.',
  NotExistKitchenCenterId: 'Kitchen center id does not exist in the system.',
  NotExistKitchenCenter: 'Kitchen center does not exist in the system.',
  NotExistBrandId: 'Brand id does not exist in the system.',
  NotExistStoreId: 'Store id does not exist in the system.',
  NotExistCategoryId: 'Category id does not exist in the system.',
  NotExistBankingAccountId: 'Banking account id does not exist in the system.',
  NotExistProductId: 'Product id does not exist in the system.',
  NotExistOrderPartnerId: 'Order parnter id does not exist in the system.',
  NotExistCashierId: 'Cashier id does not exist in the system.',
  InvalidItemsPerPage: 'Items per page number is required more than 0.',
  InvalidCurrentPage: 'Current page number is required more than 0.',
  NotExistPartnerId: 'Partner id does not exist in the system.',
  NotExistAccountId: 'Account id does not exist in the system.',
  InvalidPartnerId: 'Partner id is not suitable id in the system.',
  CategoryIdNotBelongToBrand: 'Category id does not belong to your brand.',
  CategoryIdNotBelongToStore: 'Category id does not belong to your store.',
  AlreadyExistPartnerProduct: 'Mapping product already exists in the system.',
  NotExistPartnerProduct: 'Mapping product does not exist in the system.',

  DisabledAccount: 'Account has been disabled.',
  InvalidEmailOrPassword: 'Email or Password is invalid.',

  AccountIdNotBelongYourAccount: 'Account id does not belong to your account.',
  AccountNoLongerActive: 'Your account is no longer active.',

  NotAuthenticatedEmailBefore: 'Email has not been previously authenticated.',
  ExpiredOTPCode: 'OTP code has expired.',
  NotMatchOTPCode: 'Your OTP code does not match the previously sent OTP code.',

  InvalidAccessToken: 'Access token is invalid.',
  NotExpiredAccessToken: 'Access token has not yet expired.',
  NotExistAuthenticationToken: 'You do not have the authentication tokens in the system.',
  NotExistRefreshToken: 'Refresh token does not exist in the system.',
  NotMatchAccessToken: 'Your access token does not match the registered access token.',
  ExpiredRefreshToken: 'Refresh token expired.',

  NotAuthenticatedEmail: 'Email has not been previously authenticated.',
  NotVerifiedEmail: 'Email is not yet authenticated with the previously sent OTP code.',

  DeactiveKitchenCenter_Update: 'Kitchen center was deleted before, so this kitchen center cannot update.',
  KitchenCenterManagerEmailExisted: 'Kitchen center manager email already existed in the system.',
  ExistedActiveStores_Delete: 'The kitchen center has active stores, so this kitchen center cannot be deleted.',
  NotBelongToKitchenCenter: 'Kitchen center id does not belong to your kitchen center.',
  NoOneKitchenCenterAvailable: 'There is no kitchen center available.',

  InvalidStatusFilter: 'Key status filter is required ACTIVE, INACTIVE in the system.',
  NotBelongToBrand: 'Brand id does not belong to your brand.',
  DeactiveBrand_Delete: 'Brand cannot delete because that was deleted before.',
  DeactiveBrand_Update: 'Brand was deleted before, so this brand cannot update.',
  BrandManagerEmailExisted: 'Brand manager email already existed in the system.',
  RoleNotSuitable: 'Role is not suitable',
  ProductNotBelongToBrand: 'This product not belong to brand.',
  KeySortNotExist: 'Key sort are ASC or DESC',

  BrandNotJoinKitchenCenter: 'Brand does not join into the kitchen center.',
  KitchenCenterNotHaveBrand: 'Kitchen center does not have this brand.',
  BrandNotHaveStore: 'Brand does not have this store in the system.',
  KitchenCenterNotHaveStore: 'Kitchen center does not have this store in the system.',
  DeactiveStore_Update: 'Store was deleted before, so this store cannot update.',
  DeactiveStore_Delete: 'Store cannot delete because that was deleted before.',
  ManageremailExisted: 'Store manager email already existed in the system.',
  NotConfirmingStore: 'Store is not a new store to confirm to become an ACTIVE store.',
  NotRejectedResonForNewStore: 'Rejected store registration is required a reason.',
  StoreIdDoesNotExisted: 'Store id does not existed in system.',
  StoreIdNotBelongToStore: 'Store id does not belong to your store.',
  StoreIdNotBelongToBrand: 'Store id does not belong to your brand.',
  StoresWithStatusNameParam: 'Status is required some type such as: Active, Inactive, Rejected, Be comfirming.',

  CategoryCodeExistedInBrand: 'Category code already exist in brand.',
  CategoryCodeExisted: 'Category code already exist in the system.',
  DeactiveCategory_Delete: 'Category cannot delete because that was deleted before.',
  DeactiveCategory_Update: 'Category was deleted before, so this category cannot update.',
  InvalidCategoryType: 'Type is required.',
  NotExistCategoryType: 'Type is required NORMAL or EXTRA.',
  StatusInvalid: 'Status is ACTIVE or INACTIVE.',
  CategoryMustBeNormal: 'CategoryId must be a NORMAL type.',
  ExtraCategoryGreaterThan0: 'Extra category Id must be greater than 0.',
  ListExtraCategoryIdIsExtraType: 'List extra category Id need to be a EXTRA type.',
  ListExtraCategoryIdIsActive: 'List extra category Id need status is ACTIVE.',
  ExtraCategoryIdNotBelongToBrand: 'Extra category Id does not belong to brand.',
  ExtraCategoryIdDoesNotExist: 'Extra category Id does not exist in the system.',

  BankingAccountNotBelongToKitchenCenter: 'Banking account id does not belong to your kitchen center.',
  NumberAccountExisted: 'Number account already existed in the system.',
  BankingAccountIsInactive: 'Banking account is no longer active.',

  ProductCodeExistedInBrand: 'Code already exist in brand.',
  ProductCodeExisted: 'Code already exist in the system.',
  ParentProductIdNotExist: 'Parent product id does not exist in the system.',
  ParentProductIdNotBelongToBrand: 'Parent product id does not belong to your brand.',
  CategoryNotSuitableForSingleOrParentProductType:
    'Category id is not suitable type for SINGLE or PARENT product type.',
  CategoryNotSuitableForEXTRAProductType: 'Category id is not suitable type for EXTRA product type.',
  CategoryIdNotBelongToKitchenCenter: 'Your kitchen center cannot get products with this category id.',
  InvalidProductType: 'Product type is required some types such as: SINGLE, PARENT, CHILD, EXTRA.',
  ProductIdNotBelongToBrand: 'Product id does not belong to your brand.',
  ProductNotBelongToStore: 'Product id does not belong to your store.',
  ProductNotSpendToStore: 'Product id does not spend to your kitchen center.',
  ProductNameNotFollowingFormat:
    "Name of product Type CHILD is required following format: 'ParentName - Size x' With x is a your chosen size options.",
  ProductNameTypeChildNotAllowUpdate: 'Name of product which is type CHILD does not allow update.',
  ProductIdNotParentType: 'Product id is not a PARENT type.',
  InvalidProductTypeParent: 'is invalid for product type: PARENT.',
  InvalidProductTypeChild: 'is invalid for product type: CHILD.',
  InvalidProductTypeSingle: 'is invalid for product type: SINGLE.',
  InvalidProductTypeExtra: 'is invalid for product type: EXTRA.',
  InvalidOnField: 'Invalid on field',

  DupplicatedPartnerName: 'Name already exist in the system.',
  DupplicatedWebUrl: 'Web Url already exist in the system.',
  DeactivePartner_Update: 'Partner was deleted before, so this partner cannot update.',
  DeactivePartner_Delete: 'Partner cannot delete because that was deleted before.',
  DeactivePartner_Get: 'Partner cannot get because that was deleted before.',
  PartnerHasPartnerStoreActive_Update: 'Partner can not update status because active stores is using this partner.',
  PartnerHasPartnerStoreActive_Delete: 'Partner can not delete because active stores is using this partner.',

  CashierIdNotBelongToKitchenCenter: 'Cashier id does not belong to your kitchen center.',
  CashierIdNotBelogToCashier: 'Cashier id is not suitable with your account.',
  StatusIsRequiredWithKitchenCenterManager: 'Status is not null',
  StatusIsNotRequiredWithCashier: 'Cashier does not allow to update Status property.',
  NoOneCashierAvailable: 'There is no cashier available.',

  InactiveStore_Create: 'This store has been inactive or disabled.',
  StoreNotBelongToBrand: 'Store does not belong to brand.',
  LinkedWithParner: 'This store is already linked to this partner.',
  UsernameExisted: 'Username already exist in the system.',
  NotLinkedWithParner: 'This store is not linked to this partner and it is still active.',
  DeactiveStorePartner_Update: "Can't update store partner has been deactivated.",
  DupplicatedPartnerId_Create: 'Partner Id cannot be duplicated in the partnerAccounts list.',
  GrabFoodAccountMustBeStoreManager: 'GrabFood Account must be Store Manager Role.',
  ItemOnGrabfoodCanNotMapping: 'The item on GrabFood cannot be mapped to any product in the MBKC System.',
  ModifierGroupOnGrabfoodCanNotMapping:
    'The modifier group on GrabFood cannot be mapped to any product in the MBKC System.',
  BrandHasNoActiveProduct: 'Brand has no active products',
  ParentProductMappingNotYet: 'You need to map the parent product before mapping this product.',

  ProductCodeExistedInTheSystem: 'Product Code already exist in the system.',
  DeactiveProduct_Create_Update: 'This product is Deactive.',
  InactiveProduct_Create_Update: 'This product is Inactive.',
  InactiveStore_Update: 'This store has been inactive.',

  StatusInValid: 'Status is AVAILABLE, OUT_OF_STOCK_TODAY or OUT_OF_STOCK_INDENTIFINITELY.',
  ProductCodeNotExistInGrabFoodSystem: 'Product code does not exist in the GrabFood System.',
  PriceNotMatchWithProductInGrabFoodSystem: 'Price does not match with product in the GrabFood System.',
  StatusNotMatchWithProductInGrabFoodSystem: 'Status does not match with product status in the GrabFood System.',
  ProductPartnerNotAvailableNow: 'Partner product is not available now.',
  ProductPriceNotMatchWithPartnerProduct: 'Product price does not match with partner product.',
  ExtraProductPriceNotMatchWithPartnerProduct: 'Extra Product price does not match with partner product.',
  NoOneOutOfStock: 'No partner products are out of stock.',
  UpdatePartnerProductSuccessfully: 'Change the status of partner product successfully.',

  OrderNotBelongToKitchenCenter: 'Order partner id does not belong to your kitchen center.',
  OrderShipperPhoneNotMatch: 'Shipper phone does not match with shipper phone in order.',
  OrderIsPreparing: 'This order is PREPARING status, so You can not confirm completed order.',
  OrderIsReady: 'This order is READY status, so You can not confirm completed order.',
  OrderIsUpcoming: 'This order is UPCOMING status, so You can not confirm completed order.',
  OrderIsCompleted: 'This order is already COMPLETED status, so You can not confirm completed order..',
  OrderIsCancelled: 'This order has been CANCELLED status, so You can not confirm completed order.',
  OrderAlreadyPaid: 'This order has been paid, so You can not confirm completed order.',
  OrderPartnerIdNotExist: 'Order Partner Id does not exist in the system.',
  OrderPartnerIdAlreadyExist: 'Order Partner Id already existd in the system.',
  DisplayIdAlreadyExist: 'Display Id already existd in the system.',
  ProductPartnerNotMappingBefore: "The product in the order have not yet been mapped to the store's partner product.",
  ProductExtraPartnerNotMappingBefore:
    "The extra product in the order Detail have not yet been mapped to the store's partner extra product.",
  ProductInOrderNotExistInTheSystem: 'Product Id in the Order does not exist in the system.',
  ProductExtraInOrderDetailNotExistInTheSystem: 'Product Extra Id in the Order does not exist in the system.',
  OrderIdNotExist: 'Order id does not exist in the system.',
  OrderIdNotBelongToStore: 'Order id does not belong to store.',
  OrderIdNotBelongToKitchenCenter: 'Order id does not belong to kitchen center.',
  OrderIsReady_Change_To_Ready: 'This order is READY status, so You can not change to ready.',
  OrderIsUpcoming_Change_To_Ready: 'This order is UPCOMING status, so You can not change to ready.',
  OrderIsCompleted_Change_To_Ready: 'This order is COMPLETED status, so You can not change to ready.',
  OrderIsCancelled_Change_To_Ready: 'This order is CANCELLED status, so You can not change to ready.',
  OrderIsReadyDelivery_Change_To_Ready: 'This order is READY_DELIVERY status, so You can not change to ready.',
  OrderIsPreparing_Change_To_ReadyDelivery: 'This order is PREPARING status, so You can not change to ready delivery.',
  OrderIsUpcoming_Change_To_ReadyDelivery: 'This order is UPCOMING status, so You can not change to ready delivery.',
  OrderIsCompeleted_Change_To_ReadyDelivery: 'This order is COMPLETED status, so You can not change to ready delivery.',
  OrderIsCancelled_Change_To_ReadyDelivery: 'This order is Cancelled status, so You can not change to ready delivery.',
  OrderIsReadyDelivery_Change_To_ReadyDelivery:
    'This order is READY_DELIVERY status, so You can not change to ready delivery.',
  OrderIsReady_Cancel: 'This order is READY status, so You can not cancel order.',
  OrderIsCompleted_Cancel: 'This order is COMPLETED status, so You can not cancel order.',
  OrderIsCancelled_Cancel: 'This order is CANCELLED status, so You can not cancel order.',
  OrderIsReadyDelivery_Cancel: 'This order is READY_DELIVERY status, so You can not cancel order.',
  NoChangeOrderStatusWhenClosedShift: "You've closed your shift today so you can't make a status change.",
  NoChangeOrderStatusNotToday: "Only today's order status can be changed. This order is not from today.",

  BalanceIsInvalid: 'Your balance is not enough to transfer money.',

  StoreIdNotBelogToKitchenCenter: 'Store id does not belong to your kitchen center.',
  StoreBalanceIsInvalid: 'This store balance is invalid.',
  BalanceDoesNotEnough: 'This store does not have enough balance to make a withdraw.',
  AlreadyTransferredToStore: 'The money has been transferred to the store today.',
  AlreadyTransferredToKitchenCenter: 'The money has been transferred to the kitchen center today.',
  TransferToStoreSuccessfully: 'Transfer money to store successfully.',
  TransferToKitchenCenterSuccessfully: 'Transfer money to kitchen center successfully.',
  NotExistJobId: 'Job id is not existed in the MBKC System.',
  ConfigDoesNotExist: 'Config to run background job does not exist.',

  notAccessSystem: 'You do not have access to the system',

  //Validations
  imageIsNotNull: 'Image is not null.',
  logoIsNotNull: 'Logo is not null.',
  avatarIsNotNull: 'Avatar is not null.',
};
